<div
  class="condition-if-repeat-container"
  cdkDropList
  [cdkDropListDisabled]="!props.droppable"
  [class]="field.fieldGroupClassName"
  [class.grid]="props.gridView"
  [style]="containerStyles()"
  (cdkDropListDropped)="drop($event)">
  @if (props.gridView) {
    <div class="condition-if-repeat-grid-header">
      @for (header of props.gridHeaders; track $index) {
        <div class="condition-if-repeat-grid-header-item">
          {{ header.label }}
        </div>
      }
    </div>
  }

  @for (field of field.fieldGroup; track field.id; let index = $index; let first = $first; let length = $count) {
    <div class="condition-if-repeat" cdkDrag cdkDragLockAxis="y">
      @if (props.droppable) {
        <div class="condition-if-repeat-drag" cdkDragHandle>
          <i class="icon grabbable mynaui-dots-vertical" aria-hidden="true"></i>
        </div>
      }

      @if (!props.hideConditionLabel) {
        <div class="condition-if-repeat-label">
          {{ (first ? 'flow.node.condition-if.label' : 'flow.node.operator-and.label') | translate }}
        </div>
      }

      <div class="condition-if-repeat-inputs" [class.remove-disabled]="props | disabledByProperty: field">
        <formly-field [field]="field" />
      </div>

      @if (!(props | disabledByProperty: field)) {
        <div class="condition-if-repeat-action">
          @if (length > 1 || props.noAddByDefault) {
            <i class="mynaui-x-circle clickable" (click)="remove(index)"></i>
          }
        </div>
      }
    </div>
  }
</div>

@if (!props.max || field.fieldGroup.length < props.max) {
  <div class="condition-if-repeat-buttons">
    <cap-button class="add" styleClass="primary" icon="mynaui-plus" (onClick)="add()" />
  </div>
}
